import { useState } from 'react';

// graphql
import { PageInfo, useAdt_CashierCashWithdrawalsQuery, useCashierConfirmCashWithdrawalMutation } from '@/generated/graphql';

// components
import { TableCashierCashWithdrawals } from './table';
import { IModalConfirmationDetails, ConfirmationModal } from '@/components/modal/confirmation';

// interfaces
import { ICashierCashWithdrawalQueryVariable, ICashierCashWithdrawalTable, mapGQLCashierCashWithdrawal } from '@/shared/interfaces';

interface IProps {
  refetch: () => void;
}

export const CashWithdrawals = ({ refetch }: IProps) => {
  const [cashierCashWithdrawals, setCashierCashWithdrawals] = useState<ICashierCashWithdrawalTable[]>([]);

  const [cashierCashWithdrawal, setCashierCashWithdrawal] = useState<ICashierCashWithdrawalTable | undefined>();

  const [confirmationModal, setConfirmationModal] = useState<IModalConfirmationDetails>({
    isOpen: false,
    title: 'Are you sure ?',
    messages: ['You want to confirm this transaction'],
  });

  const [cashierCashWithdrawalsQueryVariable, setCashierCashWithdrawalsQueryVariable] = useState<ICashierCashWithdrawalQueryVariable>({
    first: 25,
  });

  const [cashierCashWithdrawalsPageInfo, setCashierCashWithdrawalsPageInfo] = useState<PageInfo>();
  const [cashierCashWithdrawalsTotalCount, setCashierCashWithdrawalsTotalCount] = useState<number>(0);

  const [cashierConfirmCashWithdrawal] = useCashierConfirmCashWithdrawalMutation();

  const cashierCashWithdrawalsQuery = useAdt_CashierCashWithdrawalsQuery({
    variables: cashierCashWithdrawalsQueryVariable,
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      const mappedData = data.cashierCashWithdrawals.nodes.map((x) => mapGQLCashierCashWithdrawal(x));

      const mappedTableData: ICashierCashWithdrawalTable[] = mappedData.map((x) => ({
        id: x.id,
        amount: x.amount,
        status: x.status,
        cashierUsername: x.cashier.user.username,
        adminUsername: x.admin.user.username,
        createdAt: x.createdAt,
      }));

      setTimeout(() => {
        setCashierCashWithdrawals(mappedTableData);
        setCashierCashWithdrawalsPageInfo(data.cashierCashWithdrawals.pageInfo);
        setCashierCashWithdrawalsTotalCount(data.cashierCashWithdrawals.totalCount);
      }, 100);
    },
  });

  const transactionAction = (actionType: string, data: ICashierCashWithdrawalTable) => {
    switch (actionType) {
      case 'confirm':
        setCashierCashWithdrawal(data);
        setConfirmationModal((prev) => ({ ...prev, isOpen: true }));
        break;
      default:
        break;
    }
  };

  const confirmTransaction = () => {
    console.log(cashierCashWithdrawal);
    if (cashierCashWithdrawal) {
      setConfirmationModal((prev) => ({ ...prev, isOpen: false }));
      cashierConfirmCashWithdrawal({
        variables: {
          cashierConfirmCashWithdrawalId: cashierCashWithdrawal.id,
        },
        onCompleted: () => {
          cashierCashWithdrawalsQuery.refetch();
          refetch();
        },
      });
    }
  };

  return (
    <>
      <TableCashierCashWithdrawals
        rows={cashierCashWithdrawals}
        setCashierCashWithdrawalQueryVariable={setCashierCashWithdrawalsQueryVariable}
        cashierCashWithdrawalQueryVariable={cashierCashWithdrawalsQueryVariable}
        totalCount={cashierCashWithdrawalsTotalCount}
        pageInfo={cashierCashWithdrawalsPageInfo}
        getCashierCashWithdrawalLoading={cashierCashWithdrawalsQuery.loading}
        transactionAction={transactionAction}
      />
      <ConfirmationModal
        modalDetails={confirmationModal}
        setModalDetails={setConfirmationModal}
        confirm={confirmTransaction}
        confirmText={'confirm'}
      />
    </>
  );
};
